import React from "react";
import LeadFormHero from "./LeadFormHero";
import { Check } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="hero-wrap"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-6 py-16 lg:grid-cols-12 lg:gap-14 lg:px-10 lg:py-24">
        {/* Left copy */}
        <div className="lg:col-span-7">
          <div className="reveal d1">
            <span className="badge-pill">
              <span className="dot"><Check size={10} strokeWidth={3} /></span>
              NO FEES · NO REPAIRS · NO SHOWINGS
            </span>
          </div>

          <h1 className="font-display reveal d2 mt-7 text-[52px] sm:text-[72px] lg:text-[96px]">
            <span className="text-white">Sell your house </span>
            <span className="font-display-italic text-[var(--c4p-orange)]">for cash.</span>
            <span className="block"><span className="text-white">Close on </span><span className="font-display-italic text-[var(--c4p-orange)]">your timeline.</span></span>
          </h1>

          <p className="reveal d3 mt-7 max-w-xl font-sans-ui text-[16px] leading-relaxed text-white/85 sm:text-[17px]">
            Skip the agents, the repairs, and the waiting. Cash 4 Properties
            buys houses in any condition across Eastern North Carolina — get a
            fair, no-obligation offer in 24 hours.
          </p>

          <ul className="reveal d4 mt-8 flex flex-wrap gap-x-7 gap-y-3">
            {["As-is, any condition", "No commissions", "Close in 7 days"].map(
              (t) => (
                <li
                  key={t}
                  className="flex items-center gap-2 font-sans-ui text-[13.5px] text-white/90"
                >
                  <span className="grid h-5 w-5 place-items-center rounded-full bg-white/15">
                    <Check size={12} className="text-[var(--c4p-amber)]" strokeWidth={3} />
                  </span>
                  {t}
                </li>
              )
            )}
          </ul>
        </div>

        {/* Right: lead form */}
        <div className="lg:col-span-5">
          <div className="reveal d2">
            <LeadFormHero />
          </div>
        </div>
      </div>
    </section>
  );
}
